/** Debounce before emitting `tab:activity` after scroll/input events. */
export const TAB_ACTIVITY_DEBOUNCE_MS = 500;
